import { Provider, Type } from '@angular/core';

import { HealthChecker } from './health-checker';

import { HEALTH_CHECKERS } from './health-checkers.token';

export function provideHealthCheckers(checkers: Type<HealthChecker>[]): Provider[] {
  return checkers.map((checker) => ({
    multi: true,
    provide: HEALTH_CHECKERS,
    useClass: checker,
  }));
}
